import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'config/axios';

import { setErrors, setReportCompanies, setLatestReportDate} from 'stores/modules/vapt/reportreducer';

export const fetchReportCompanies = createAsyncThunk('company/fetchReportCompanies', async (params, { dispatch }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/companies`, {
      params: params,
      headers: {
        'x-app-slug': 'vapt',
      }
    });
    dispatch(setReportCompanies(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const updateRequestReport = async ({ payload }) => {
  try {
    let response = await axios.post(`${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/report`, payload, {
      headers: {
        'x-app-slug': 'vapt',
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};



export const fetchReports = async (params) => {
  try {
    const updatedParams = { ...params, page: params.page, limit: params.limit };
    if (params.search) {
      updatedParams.search = params.search;
    }
    let response = await axios.get(`${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/reports`, {
      params: updatedParams,
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const updateReportStatus = createAsyncThunk('report/updateReport', async ({ idToken, reportId, reportStatus }, { dispatch }) => {
  try {
    const data = { reportStatus };
    const response = await axios.put(
      `${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/report/${reportId}`,
      data,
      {
        'Content-Type': 'application/json',
      }
    );
    return response.status;
  } catch (error) {
    return error?.response?.data?.message;
  }
});

export const uploadVulnerability =  async (formData) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_VAPT_ALERT_ENDPOINT_URL}/alert`,
      formData,
      {
        'Content-Type': 'application/json',
      }
    );
    if (response.status === 200 || response?.status === 201){
      return "success";
    }
  } catch (error) {
    return error;
  }
};

export const fetchReportsQuery = async ({reportId}) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/reports/query`,
      {
        params: { reportId }
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updatePDFReports = async ({ reportId, formData }) => {
  try {
    let response = await axios.post(`${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/ppt-report/${reportId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchPDFReports = async () => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/pdf-reports`, {
      params: {
        limit: 'null'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchPDFReportsBYID = async ({ selectedReportId }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/pdf-report/${selectedReportId}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const editVulnerability =  async (formData,id) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_VAPT_ALERT_ENDPOINT_URL}/alert/${id}`,
      formData,
      {
        'Content-Type': 'application/json',
      }
    );
    if (response.status === 200 || response?.status === 201){
      return "success";
    }
  } catch (error) {
    return error;
  }
};

export const fetchLatestReportDate = createAsyncThunk('data/fetchLatestReportDate', async ({ idToken, params }, { dispatch }) => {
  try {
    dispatch(setLatestReportDate(null));
    dispatch(setErrors([]));
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/latest-report-date`, {
      params: params,
    });
    dispatch(setLatestReportDate(response.data.date));
  } catch (error) {
    dispatch(setLatestReportDate(null));
    dispatch(setErrors(error?.response?.data?.message));
  }
});

export const fetchReportDates = async ({ idToken, params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/report-dates`, {
      params: params,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};

export const downloadReport = async (reportId) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_VAPT_REPORT_PDF_ENDPOINT_URL}/excel_doc/${reportId}`, {
      responseType: 'json'
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchPPTReports = async ( params ) => {
  try {
    const updatedParams = { ...params, page: params.page, limit: params.limit };
    if (params.search) {
      updatedParams.search = params.search;
    }
    let response = await axios.get(`${process.env.REACT_APP_VAPT_REPORT_ENDPOINT_URL}/ppt-reports`, {
      params: updatedParams,
    });
    return response;
  } catch (error) {
    return error;
  }
};